/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import {
  FORGOT_PASSWORD,
  PHONE_VERIFICATION_TEXTS,
  PHONE_VERIFICATION_SUCCESS_TEXTS,
} from '../../shared/constants';
import BtnComponent from '../buttonComponent/BtnComponent';
import { TimerComponent } from '../OTPVerification/TimerComponent';
import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import {
  GENERATE_OTP,
  VALIDATE_OTP,
} from '../../services/userQueries/userService';
import { useSnackbar } from 'notistack';
import { useTimer } from '../../shared/useTimer';
import { CollectionsOutlined } from '@mui/icons-material';
import { SimpleBackdrop } from '../SimpleBackdropComponent/SimpleBackdrop';
import { ERROR_MSGS, CHANGE_PASSWORD } from '../../shared/Strings';

const textWrapper = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  flexDirection: 'row',
  mt: '12px',
};
const otpFiledWrapper = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  flexDirection: 'row',
  mt: '32px',
};
const otparray = {
  textAlign: 'center',
  border: '1px solid #CCCCCC',
  width: '100%',
  fontSize: '28px',
  fontWeight: 600,
  maxWidth: '100px',
  minHeight: '100px',
  borderRadius: '4px',
  marginRight: '12px',
};
const btnComponent = { width: '100%', maxWidth: '476px', mt: '32px' };

const ChangePassword = props => {
  const phoneNumber = props.phoneNumber;
  const [otp, setOtp] = useState(new Array(4).fill(''));
  const [validateOTPDisabled, setValidateOTPDisabled] = useState(true);
  const { enqueueSnackbar } = useSnackbar();
  const [verificationSid, setVerificationSid] = useState(null);

  const [resendOTP, resendOTPCall] = useLazyQuery(GENERATE_OTP, {
    fetchPolicy: 'no-cache',
    onError: err => {
      enqueueSnackbar(ERROR_MSGS.WENT_WRONG_REGENERATING_OTP, {
        variant: 'error',
      });
      setResendTime(0);
    },
  });

  const [resendTime, setResendTime] = useTimer({
    startTime: 59,
    multiplier: 1,
    direction: 'down',
    endTime: 0,
    timeOut: 1000,
  });

  const handleChange = (element, index) => {
    if (isNaN(element.value)) {
      return false;
    }
    setOtp([...otp.map((d, idx) => (idx === index ? element.value : d))]);
    if (index === 3 && element.value) setValidateOTPDisabled(false);
    else setValidateOTPDisabled(true);

    if (element.value && element.nextSibling) {
      element.nextSibling.focus();
    }
    if (!element.value) {
      element.previousSibling.focus();
    }
  };

  const handleResend = () => {
    resendOTP({ variables: { phone: phoneNumber } });
    CollectionsOutlined.log(resendOTP);
  };
  const handleClearotp = e => {
    setOtp([...otp.map(v => '')]);
  };

  const handleRedirection = () => {
    const otpValue = otp.join('');
    validateOTP({
      variables: {
        validateOTPRequest: {
          verificationSid: verificationSid,
          otp: otpValue,
          phoneNumber: phoneNumber,
        },
        userId: '',
      },
    });
  };
  const generateOTP = useQuery(GENERATE_OTP, {
    fetchPolicy: 'no-cache',
    variables: { phone: props?.phoneNumber },
    onError: err => {
      enqueueSnackbar(ERROR_MSGS.WENT_WRONG_GENERATING_OTP, {
        variant: 'error',
      });
      setResendTime(0);
    },
  });

  const [validateOTP, validateOTPCall] = useMutation(VALIDATE_OTP, {
    onError: err => {
      enqueueSnackbar(ERROR_MSGS.WENT_WRONG_VALIDATING_OTP, {
        variant: 'error',
      });
    },
  });

  useEffect(() => {
    if (resendOTPCall?.data?.generateOTPUnAuthMember) {
      setVerificationSid(
        resendOTPCall.data.generateOTPUnAuthMember.verificationSid
      );
      enqueueSnackbar(CHANGE_PASSWORD.OTP_RESEND_SUCCESS, {
        variant: 'success',
      });
      setResendTime(59);
    } else if (generateOTP?.data?.generateOTPUnAuthMember) {
      setVerificationSid(
        generateOTP.data.generateOTPUnAuthMember.verificationSid
      );
      enqueueSnackbar(CHANGE_PASSWORD.OTP_SEND_SUCCESS, {
        variant: 'success',
      });
      setResendTime(59);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    resendOTPCall?.data?.generateOTPUnAuthMember,
    generateOTP?.data?.generateOTPUnAuthMember,
  ]);

  useEffect(() => {
    if (
      validateOTPCall?.data?.validateOTPUnAuthMember
        ?.phoneVerificationStatus ===
      PHONE_VERIFICATION_SUCCESS_TEXTS.PHONE_VERIFICATION_STATUS.PENDING
    ) {
      enqueueSnackbar(ERROR_MSGS.WRONG_OTP, {
        variant: 'error',
      });
      handleClearotp();
    } else if (
      validateOTPCall?.data?.validateOTPUnAuthMember
        ?.phoneVerificationStatus ===
      PHONE_VERIFICATION_SUCCESS_TEXTS.PHONE_VERIFICATION_STATUS.EXPIRED
    ) {
      enqueueSnackbar(ERROR_MSGS.OTP_EXPIRED, {
        variant: 'error',
      });
      setResendTime(0);
    } else if (
      validateOTPCall?.data?.validateOTPUnAuthMember
        ?.phoneVerificationStatus ===
      PHONE_VERIFICATION_SUCCESS_TEXTS.PHONE_VERIFICATION_STATUS.APPROVED
    ) {
      props.setScreenNumber(3);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validateOTPCall?.data?.validateOTPUnAuthMember]);

  return (
    <Box>
      <Typography variant="title">{FORGOT_PASSWORD.TITLE}</Typography>
      <Box sx={textWrapper}>
        <Typography sx={{ mr: 0.5 }}>{FORGOT_PASSWORD.TEXT}</Typography>
        <Box sx={{ mr: 1, color: 'primary.main', fontWeight: 600 }}>
          ({phoneNumber})
        </Box>
      </Box>

      <Box sx={otpFiledWrapper}>
        {otp.map((data, index) => {
          return (
            <input
              style={otparray}
              type="text"
              name="otp"
              maxLength="1"
              key={index}
              value={data}
              onChange={e => handleChange(e.target, index)}
              onFocus={e => e.target.select()}
            />
          );
        })}
      </Box>
      <BtnComponent
        sx={btnComponent}
        onClick={handleRedirection}
        title={CHANGE_PASSWORD.SAVE_CHANGES}
        fullWidth
        disabled={validateOTPDisabled}
      />
      <Typography
        sx={{
          mt: '40px',
          color: '#000000',
        }}>
        {PHONE_VERIFICATION_TEXTS.NO_RECEIVE}
      </Typography>
      {resendTime !== 0 ? (
        <TimerComponent resendTime={resendTime} />
      ) : (
        <Box
          sx={{
            '&:hover': { bgcolor: 'transparent', cursor: 'pointer' },
            color: '#0060BA',
            fontWeight: 'normal',
            fontSize: '14px',
            lineHeight: '20px',
            mt: '11px',
          }}>
          <a type="button" onClick={handleResend}>
            {FORGOT_PASSWORD.RESEND_OTP}
          </a>
        </Box>
      )}
      <SimpleBackdrop
        open={
          resendOTPCall?.loading ||
          validateOTPCall?.loading ||
          generateOTP?.loading
        }
      />
    </Box>
  );
};

export default ChangePassword;
